import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/erlang': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M21.7 246.4C21.6 333.2 50.7 405.9 100.4 458.5H0V53.5H87.2C45.7 103.7 21.6 169.7 21.7 246.4zM640 53.6H556.4C587.8 96.3 605.1 151.1 602.6 216.3 603.1 222.3 603.1 228 602.6 240.4H230.2C230 350.1 269.1 435.3 368.8 435.7 437.3 435.4 486.8 384.7 520.7 329.6L617.1 377.8C599.7 408.7 580.6 435.6 559.2 458.6H640V53.6zM559.2 458.6S559.2 458.5 559.2 458.6H559 559.2zM556.1 53.6H556.4L556.3 53.5 556.1 53.6zM325.4 63.2C279.5 63.3 240.3 96.7 236.2 146.4H406.1C405 96.7 371.6 63.3 325.4 63.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/erlang.js
// module id = RXQD
// module chunks = 144